import React, { useState, useCallback } from "react"
import { View, Text, GestureResponderEvent, TouchableOpacity, Platform } from "react-native"
import PhoneInput, { ICountry } from "react-native-international-phone-number"
import { useFonts } from "expo-font"
import { colors } from "colors"
import { typography } from "theme"
import { style as styles } from "./styles"
import { CustomPhoneNumberInputProps } from "./props"
import Icon from "@expo/vector-icons/Feather"

export const PhoneNumberInput: React.FC<CustomPhoneNumberInputProps> = ({
  value,
  onChange,
  onCustomFocus,
  fieldError,
  errorMessage,
  placeholder,
  defaultCountry = "MY",
  title,
  editable = true,
  containerStyle,
  inputStyle,
  wrapperStyle,
  titleStyle,
  errorTextStyle,
  onPress,
  onBlur,
  onCountryChange,
}) => {
  const [selectedCountry, setSelectedCountry] = useState<null | ICountry>(null)
  const [isFocused, setIsFocused] = useState(false)

  const handleFocus = useCallback(() => {
    setIsFocused(true)
    if (onCustomFocus) {
      onCustomFocus()
    }
  }, [onCustomFocus])

  const handleBlur = useCallback(() => {
    setIsFocused(false)
    onBlur && onBlur()
  }, [])

  return (
    <View style={wrapperStyle}>
      <View style={styles.titleContainer}>
        {title && <Text style={[styles.title, titleStyle]}>{title}</Text>}
      </View>
      <TouchableOpacity onPress={onPress && onPress}>
        <PhoneInput
          customCaret={<Icon name="chevron-down" size={20} color="#000000" />}
          value={value}
          onChangePhoneNumber={(formattedPhoneNumber) => {
            onChange(formattedPhoneNumber, selectedCountry)
          }}
          selectedCountry={selectedCountry}
          onChangeSelectedCountry={(country: ICountry) => {
            setSelectedCountry(country)
            if (onCountryChange) {
              onCountryChange(country)
            }
            if (value) {
              onChange(`${value.replace(/[^0-9]/g, "")}`, country)
            }
          }}
          defaultCountry={defaultCountry}
          placeholder={placeholder}
          disabled={!editable}
          keyboardType="numeric"
          onFocus={handleFocus}
          onBlur={handleBlur}
          phoneInputStyles={{
            container: [
              {
                borderRadius: 999,
                alignItems: "center",
                backgroundColor: "transparent",
                borderColor: fieldError ? colors.error : colors.inputFieldBorder,
                borderWidth: 1,
                flexDirection: "row",
                justifyContent: "center",
                paddingRight: 10,
                marginBottom: 6,
                height: 50,
              },
              containerStyle,
            ],
            input: [
              {
                fontSize: 14,
                fontFamily: typography.primary.normal,
              },
              inputStyle,
            ],
            flagContainer: {
              borderRadius: 999,
              borderTopLeftRadius: 999,
              borderBottomLeftRadius: 999,
              backgroundColor: "white",
            },

            callingCode: {
              fontFamily: typography.primary.normal,
              fontSize: 14,
            },
          }}
        />
      </TouchableOpacity>
      {fieldError && errorMessage && (
        <Text style={[styles.errorText, errorTextStyle]}>{errorMessage}</Text>
      )}
    </View>
  )
}
